import { Avatar as AvatarMui, SxProps } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useImage } from "../../../api/useImage";

type AvatarProps = {
    value?: string;
    styles?: SxProps;
};

export function Avatar({ value, styles }: AvatarProps) {
    const { data } = useImage(value);

    if (!data) {
        const placeholderStyle = styles ?? { fontSize: "2.19rem" }; // mirrors fontSize="large"
        return <AccountCircle sx={placeholderStyle} color="disabled" />;
    }

    return <AvatarMui sx={styles} src={data} />;
}
